var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1H512V343H0V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1H512V92.2H0V1ZM0 251.8H512V343H0V251.8Z",
    fill: "#D03433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 92H512V252H0V92Z",
    fill: "#FBCA46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.493 160.6H200.249V172H177.493V160.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.84 194.8C163.84 201.64 170.667 206.2 177.493 206.2C184.32 206.2 191.147 201.64 191.147 194.8L193.422 160.6H161.564L163.84 194.8ZM150.187 160.6C150.187 153.76 154.738 149.2 159.289 149.2H193.422C200.249 149.2 204.8 153.76 204.8 158.32V160.6L202.524 194.8C200.249 208.48 191.147 217.6 177.493 217.6C163.84 217.6 154.738 208.48 152.462 194.8L150.187 160.6Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.738 172H200.249V183.4H188.871L177.493 206.2L166.116 183.4H154.738V172ZM120.604 137.8H143.36V217.6H120.604V137.8ZM211.627 137.8H234.382V217.6H211.627V137.8ZM154.738 126.4C154.738 119.56 159.289 115 166.116 115H188.871C195.698 115 200.249 119.56 200.249 126.4V130.96C200.249 135.52 197.973 137.8 193.422 137.8H159.289C157.013 137.8 154.738 135.52 154.738 133.24V126.4Z",
    fill: "#A41517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.73029c1097162444cbd3f1acf4580cb2.svg";
export { ForwardRef as ReactComponent };